export function formatMaskedProductKey(maskedPrefix: string | null | undefined, maskedSuffix: string) {
  if (!maskedPrefix) return `•••• ${maskedSuffix}`;
  return `${maskedPrefix}-*****-*****-*****-${maskedSuffix}`;
}
